var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.168 19.3652H7.20703C5.99533 19.3652 5.00977 18.3797 5.00977 17.168V7.20703C5.00977 5.99533 5.99533 5.00977 7.20703 5.00977H17.168C18.3797 5.00977 19.3652 5.99533 19.3652 7.20703V17.168C19.3652 18.3797 18.3797 19.3652 17.168 19.3652ZM7.20703 6.47461C6.80317 6.47461 6.47461 6.80317 6.47461 7.20703V17.168C6.47461 17.5718 6.80317 17.9004 7.20703 17.9004H17.168C17.5718 17.9004 17.9004 17.5718 17.9004 17.168V7.20703C17.9004 6.80317 17.5718 6.47461 17.168 6.47461H7.20703ZM3.54492 13.5059H2.8125C2.40864 13.5059 2.08008 13.1773 2.08008 12.7734V2.8125C2.08008 2.40864 2.40864 2.08008 2.8125 2.08008H12.7734C13.1773 2.08008 13.5059 2.40864 13.5059 2.8125V3.5083H14.9707V2.8125C14.9707 1.6008 13.9851 0.615234 12.7734 0.615234H2.8125C1.6008 0.615234 0.615234 1.6008 0.615234 2.8125V12.7734C0.615234 13.9851 1.6008 14.9707 2.8125 14.9707H3.54492V13.5059Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.8e0e88029c96ab36d8ad23d66236d5a3.svg";
export { ForwardRef as ReactComponent };